<template >
    <span>
      <div class="block-layout questionnaire" id="scrollableques" :class="{ 'padt20': !checkCurrentUrl }">
        <div class="vx-col w-full wizard-container form_section  questionnairesection pad0 case-form-v2">
          <div class="questionnaire_page" id="questionnaire_page"  v-if="petition && questionnaireDetails!=null">
            <div class="questionnaire_sec">
              <div class="questionnaire_titles">
                <div class="questionnaire_titles_info"  v-if="petition && questionnaireDetails!=null">
                    <h2  v-if="getCaseName" v-html="getCaseName"></h2>
                    <h2 v-else>
                        Questionnaire for {{checkProperty(petition, 'typeDetails', 'name')}}
                        <small v-if="checkProperty(petition, 'subTypeDetails')">{{checkProperty(petition, 'subTypeDetails', 'name')}}</small>
                    </h2>
                    <p>
                        Please take a few moments to complete this short registration form
                    </p>
                    <ul>
                        <template v-for="(item,index) in tabslist">
                            <li :key="index" :class="{'active':currentTab==item.key || (index<=checkActiveTab && currentTab!=item.key)} " @click="setActiveTab(item.key,true)">
                                <span>{{index+1}}</span><a>{{item.name}}</a>
                            </li>
                        </template>  
                    </ul>
                    <ul v-if="checkProperty($route ,'name') !='fill-Petitioner-questionnaire' && checkProperty(petition, 'completedActivities') && checkProperty(petition, 'completedActivities', 'length')>0 && 
                        checkProperty(petition, 'completedActivities').indexOf('SUBMIT_BY_PETITIONER')>-1">
                        <vs-button color="primary" type="border" class="primary_btn delete_btn light-blue-btn assign_bulk_btn"
                        @click="reloadthePage(true)">Continue to fill Beneficiary Questionnaire </vs-button>  
                    </ul>
                </div>
                <figure><img src="@/assets/images/main/content-bottom-image.svg" /></figure>
              </div>
              <div class="questionnaire_form">
                <div id="case_details_dt" v-if="currentTab == 'casedetails'">
                  <form data-vv-scope="casedetailsform">
                    <div class="vs-col w-full p-0 vs-xs- vs-sm- vs-lg-">
                      <div class="con-vs-alert warning-alert top-warning-alert con-vs-alert-warning con-icon">
                        <div class="vs-alert con-icon">
                          <i class="vs-icon notranslate icon-scale icon-alert IntakePortal IP-information-button null"></i>
                          NOTE: This questionnaire should be filled out completely and
                          accurately. Kindly read the instructions carefully. 
                        </div>
                      </div>
                    </div>
                    <div class="vs-col m-auto float-none vs-xs- vs-sm-12 vs-lg-12">
                      <div class="form-container pt-10 form-container-questionnaire">
                        <div class="vx-row  pt-10">
                            <!-- @input="updateL1Docs" -->
                            <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'benfComeToUSOpenNewOffice','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'benfComeToUSOpenNewOffice'" 
                            :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="benfComeToUSOpenNewOffice"  v-model="petition.petitionerQuestInfo.benfComeToUSOpenNewOffice" :tplsection="'petitionerQuestInfo'"  :fieldName="'benfComeToUSOpenNewOffice'"  label="Is the beneficiary coming to the United States to open a new office?"></immiyesorno>
                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('classificationScougt',questionnaireDetails, false, 'petitionerQuestInfo' )">
                                <div class="custom-radio_sec">
                                    <a class="switch-label">
                                        Classification sought
                                    </a><em v-if="checkFieldIsRequired({'key':'classificationScougt','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                    <ul class="custom-radio custom-radio_v2">
                                        <li>
                                            <vs-radio ref="_L-1A" v-model="petition.petitionerQuestInfo.classificationScougt" vs-name="L-1A" :vs-value="'L-1A'"  >L-1A manager or executive</vs-radio>
                                        </li>
                                        <li>
                                            <vs-radio ref="_L-1B" v-model="petition.petitionerQuestInfo.classificationScougt" vs-name="L-1B" :vs-value="'L-1B'" >L-1B specialized knowledge</vs-radio>
                                        </li> 
                                    </ul>
                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'classificationScougt','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                        <input type="hidden" :name="'otherNames_classificationScougt'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.petitionerQuestInfo.classificationScougt">
                                        <span v-show="errors.has( 'casedetailsform.otherNames_classificationScougt')" class="text-danger text-sm" style="">*Field is required</span>
                                    </div>
                                </div>
                            </div>
                            <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="nameOfEmpAbroad" 
                            formscope="casedetailsform" v-model="petition.petitionerQuestInfo.nameOfEmpAbroad"
                            :tplsection="'petitionerQuestInfo'" :tplkey="'nameOfEmpAbroad'" :fieldName="'nameOfEmpAbroad'" :required="false"
                            label="Name of Employer Abroad" placeHolder="Name of Employer Abroad" />
                            <div class="vx-col w-full">
                                <template v-if="countries.length>0">
                                    <div v-if="canRenderField('address',questionnaireDetails, false, 'petitionerQuestInfo' )">
                                        <h3 class="small-header">Address of Employer Abroad</h3>
                                        <addressField 
                                        :fieldsArray="questionnaireDetails" formscope="casedetailsform" :showaptType="true" 
                                        :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'address','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })"
                                        :countries="countries" v-model="petition.petitionerQuestInfo.address" :tplsection="'petitionerQuestInfo'"  :fieldName="'address'"  :cid="'petitionerQuestInfoAddress'" />
                                    </div>
                                </template>
                            </div>
                            <template v-if="canRenderField('dateOfBenfEmployment',questionnaireDetails, false, 'petitionerQuestInfo.dateOfBenfEmployment')">
                                <div class="vx-col w-full" v-if="checkProperty(petition.petitionerQuestInfo,'dateOfBenfEmployment') && checkProperty(petition.petitionerQuestInfo,'dateOfBenfEmployment' ,'length')>0">     
                                    <h3 class="small-header" style="margin-bottom:0 !important;padding-bottom:0 !important">Dates of beneficiary's employment with this employer</h3>
                                        <div class="I-485-wrapper">
                                            <div class="vx-row delete-row I-485-bg" v-for="(item, index) in petition.petitionerQuestInfo['dateOfBenfEmployment']" :key="index">
                                            <div class="w-full">
                                                <div class="vx-row"> 
                                                    <datepickerField  @input="clearStartandEnddate($event,'dateOfBenfEmployment',index,'start')" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfEmpFrom'"  :validationRequired="true" v-model="item.dateOfEmpFrom" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'petitionerQuestInfo.dateOfBenfEmployment'"  :fieldName="'dateOfEmpFrom'+index" :cid="'dateOfEmpFrom'+index"  label="Dates of Employement From" />
                                                    <datepickerField @input="clearStartandEnddate($event,'dateOfBenfEmployment',index,'end')"   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfEmpTo'" :isDisabled="!item.dateOfEmpFrom"  :validationRequired="true" v-model="item.dateOfEmpTo" :dateEnableFrom="item.dateOfEmpFrom" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'petitionerQuestInfo.dateOfBenfEmployment'" :cid="'dateOfEmpTo'+index"  :fieldName="'dateOfEmpTo'+index"  label="Dates of Employement To" />
                                                    <div class="vx-col w-full ownership_editor" v-if="canRenderField('explaOfInterruptions',questionnaireDetails,false ,'petitionerQuestInfo.dateOfBenfEmployment')">
                                                        <div class="form_group">
                                                            <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="item.explaOfInterruptions" :tplsection="'petitionerQuestInfo.dateOfBenfEmployment'" :tplkey="'explaOfInterruptions'" :fieldName="'explaOfInterruptions'"  :required="true"  :customValidNotRequire="true" :label="'Explanation of Interruptions'" :placeHolder="'Explanation of Interruptions'"  :canSpellCheck="true"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                <div class="delete" v-if="checkProperty(petition.petitionerQuestInfo, 'dateOfBenfEmployment', 'length') > 1">
                                                    <a @click="removeBenEmpDates(index)">
                                                    <img src="@/assets/images/main/delete-row-img-white.svg" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>                                 
                                    <div class="m-auto  mb-3" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                            <a @click="addBenEmpDates()" class="add-more ml-0 mt-4" style="display:inline-block" type="filled">
                                        <span>+</span> More</a>
                                    </div>
                                </div>
                            </template>
                            <div class="vx-col w-full  ownership_editor" v-if="canRenderField('descBenfDutAbroad3Years',questionnaireDetails,false ,'petitionerQuestInfo')">
                                <div class="form_group">
                                    <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.petitionerQuestInfo.descBenfDutAbroad3Years" :tplsection="'petitionerQuestInfo'" :tplkey="'descBenfDutAbroad3Years'" :fieldName="'descBenfDutAbroad3Years'"  :required="true"  :customValidNotRequire="true" 
                                    label="Describe the beneficiary's duties abroad for the 3 years preceding the filing of the petition" placeHolder="Describe the beneficiary's duties abroad for the 3 years preceding the filing of the petition"  :canSpellCheck="true"/>
                                </div>
                            </div>
                            <div class="vx-col w-full  ownership_editor" v-if="canRenderField('descBenfPropDutiesInUs',questionnaireDetails,false ,'petitionerQuestInfo')">
                                <div class="form_group">
                                    <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.petitionerQuestInfo.descBenfPropDutiesInUs" :tplsection="'petitionerQuestInfo'" :tplkey="'descBenfPropDutiesInUs'" :fieldName="'descBenfPropDutiesInUs'"  :required="true"  :customValidNotRequire="true" 
                                    label="Describe the beneficiary's proposed duties in the United States." placeHolder="Describe the beneficiary's proposed duties in the United States."  :canSpellCheck="true"/>
                                </div>
                            </div>
                            <div class="vx-col w-full ownership_editor" v-if="canRenderField('sumBenfEduAndWorkExp',questionnaireDetails,false ,'petitionerQuestInfo')">
                                <div class="form_group">
                                    <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.petitionerQuestInfo.sumBenfEduAndWorkExp" :tplsection="'petitionerQuestInfo'" :tplkey="'sumBenfEduAndWorkExp'" :fieldName="'sumBenfEduAndWorkExp'"  :required="true"  :customValidNotRequire="true" 
                                    label="Summarize the beneficiary's education and work experience" placeHolder="Summarize the beneficiary's education and work experience"  :canSpellCheck="true"/>
                                </div>
                            </div>
                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('companyRelaToAbroad',questionnaireDetails, false, 'petitionerQuestInfo' )">
                                <div class="custom-radio_sec">
                                    <a class="switch-label">
                                        How is the U.S. company related to the company abroad?
                                    </a><em v-if="checkFieldIsRequired({'key':'companyRelaToAbroad','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                    <ul class="custom-radio custom-radio_v2">
                                        <li>
                                            <vs-radio ref="_Parent" v-model="petition.petitionerQuestInfo.companyRelaToAbroad" vs-name="Parent" :vs-value="'Parent'"  >Parent</vs-radio>
                                        </li>
                                        <li>
                                            <vs-radio ref="_Branch" v-model="petition.petitionerQuestInfo.companyRelaToAbroad" vs-name="Branch" :vs-value="'Branch'" >Branch</vs-radio>
                                        </li> 
                                        <li>
                                            <vs-radio ref="_Subsidiary" v-model="petition.petitionerQuestInfo.companyRelaToAbroad" vs-name="Subsidiary" :vs-value="'Subsidiary'" >Subsidiary</vs-radio>
                                        </li>
                                        <li>
                                            <vs-radio ref="_Affiliate" v-model="petition.petitionerQuestInfo.companyRelaToAbroad" vs-name="Affiliate" :vs-value="'Affiliate'" >Affiliate</vs-radio>
                                        </li>
                                        <li>
                                            <vs-radio ref="_Joint Venture" v-model="petition.petitionerQuestInfo.companyRelaToAbroad" vs-name="Joint Venture" :vs-value="'Joint Venture'" >Joint Venture</vs-radio>
                                        </li>
                                    </ul> 
                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'companyRelaToAbroad','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                        <input type="hidden" :name="'otherNames_companyRelaToAbroad'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.petitionerQuestInfo.companyRelaToAbroad">
                                        <span v-show="errors.has( 'casedetailsform.otherNames_companyRelaToAbroad')" class="text-danger text-sm" style="">*Field is required</span>
                                    </div>
                                </div>
                            </div>
                            <template v-if="canRenderField('desPerStockOwnerShip',questionnaireDetails, false, 'petitionerQuestInfo.desPerStockOwnerShip')">
                                <div class="vx-col w-full" v-if="checkProperty(petition.petitionerQuestInfo,'desPerStockOwnerShip') && checkProperty(petition.petitionerQuestInfo,'desPerStockOwnerShip' ,'length')>0">     
                                    <h3 class="small-header" style="margin-bottom:0 !important;padding-bottom:0 !important">Describe the percentage of stock ownership and managerial control of each company that has a qualifying relationship. Provide the Federal Employer Identification Number for each U.S. company that has a qualifying relationship.</h3>
                                        <div class="I-485-wrapper">
                                            <div class="vx-row delete-row I-485-bg" v-for="(item, index) in petition.petitionerQuestInfo['desPerStockOwnerShip']" :key="index">
                                            <div class="w-full">
                                                <div class="vx-row"> 
                                                    <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="perOfCompany" 
                                                    formscope="casedetailsform" v-model="item.perOfCompany"  
                                                    :tplsection="'petitionerQuestInfo.desPerStockOwnerShip'" :tplkey="'perOfCompany'" :fieldName="'perOfCompany'" :required="false"
                                                    label="Percentage of company stock ownership" placeHolder="Percentage of company stock ownership" 
                                                    :helpText="'Percentage of company stock ownership and managerial control of each company that has a qualifying relationship.'" />
                                                    <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="fedEmpIdentification" 
                                                    formscope="casedetailsform" v-model="item.fedEmpIdentification"  
                                                    :tplsection="'petitionerQuestInfo.desPerStockOwnerShip'" :tplkey="'fedEmpIdentification'" :fieldName="'fedEmpIdentification'" :required="false"
                                                    label="Federal Employer Identification Number" placeHolder="Federal Employer Identification Number"
                                                    :helpText="'Federal Employer Identification Number for each U.S. company that has a qualifying relationship'" />
                                                </div>
                                            </div>
                                                <div class="delete" v-if="checkProperty(petition.petitionerQuestInfo, 'desPerStockOwnerShip', 'length') > 1">
                                                    <a @click="removeStockOwner(index)">
                                                    <img src="@/assets/images/main/delete-row-img-white.svg" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>                                 
                                    <div class="m-auto  mb-3" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                            <a @click="addStockOwner()" class="add-more ml-0 mt-4" style="display:inline-block" type="filled">
                                        <span>+</span> More</a>
                                    </div>
                                </div>
                            </template>
                            <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'everqualRelaOneYearEmpl','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'everqualRelaOneYearEmpl'"
                            :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="everqualRelaOneYearEmpl"  v-model="petition.petitionerQuestInfo.everqualRelaOneYearEmpl" :tplsection="'petitionerQuestInfo'"  :fieldName="'everqualRelaOneYearEmpl'"  label="Do the companies currently have the same qualifying relationship as they did during the one-year period of the beneficiary's employment with the company abroad?"></immiyesorno>
                            <div class="vx-col w-full  ownership_editor" v-if="checkProperty(petition, 'petitionerQuestInfo', 'everqualRelaOneYearEmpl') == false && canRenderField('everqualRelaOneYearEmplExpla',questionnaireDetails,false ,'petitionerQuestInfo')">
                                <div class="form_group">
                                    <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.petitionerQuestInfo.everqualRelaOneYearEmplExpla" :tplsection="'petitionerQuestInfo'" :tplkey="'everqualRelaOneYearEmplExpla'" :fieldName="'everqualRelaOneYearEmplExpla'"  :required="true"  :customValidNotRequire="true" 
                                    label="Provide an explanation" placeHolder="Provide an explanation"  :canSpellCheck="true"/>
                                </div>
                            </div>
                            <div class="vx-col w-full">
                                <h3 class="small-header">Offsite Work Location</h3>
                            </div>
                            <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'benePriOffsiteEmp','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'benePriOffsiteEmp'"
                            :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="benePriOffsiteEmp"  v-model="petition.petitionerQuestInfo.benePriOffsiteEmp" :tplsection="'petitionerQuestInfo'"  :fieldName="'benePriOffsiteEmp'"  label="Will the beneficiary be stationed primarily offsite"></immiyesorno>
                            <div class="vx-col w-full  ownership_editor" v-if="checkProperty(petition, 'petitionerQuestInfo', 'benePriOffsiteEmp') == true && canRenderField('priOffsiteEmpExpla',questionnaireDetails,false ,'petitionerQuestInfo')">
                                <div class="form_group">
                                    <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.petitionerQuestInfo.priOffsiteEmpExpla" :tplsection="'petitionerQuestInfo'" :tplkey="'priOffsiteEmpExpla'" :fieldName="'priOffsiteEmpExpla'"  :required="true"  :customValidNotRequire="true" 
                                    label="Describe how and by whom the beneficiary's work will be controlled and supervised" placeHolder="Describe how and by whom the beneficiary's work will be controlled and supervised"  :canSpellCheck="true"/>
                                </div> 
                            </div>
                            <div class="vx-col w-full  ownership_editor" v-if="checkProperty(petition, 'petitionerQuestInfo', 'benePriOffsiteEmp') == true && canRenderField('priReasplaceToAnotWorksite',questionnaireDetails,false ,'petitionerQuestInfo')">
                                <div class="form_group">
                                    <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.petitionerQuestInfo.priReasplaceToAnotWorksite" :tplsection="'petitionerQuestInfo'" :tplkey="'priReasplaceToAnotWorksite'" :fieldName="'priReasplaceToAnotWorksite'"  :required="true"  :customValidNotRequire="true" 
                                    label="Describe the reasons why placement at another worksite outside the petitioner, subsidiary, affiliate, or parent is needed" placeHolder="Describe the reasons why placement at another worksite outside the petitioner, subsidiary, affiliate, or parent is needed"  :canSpellCheck="true"/>
                                </div>
                            </div>
                            <div class="vx-col w-full">
                                <h3 class="small-header">Basic Information About the Proposed Employment and Employer</h3>
                            </div>
                            <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="jobTitle" 
                            formscope="casedetailsform" v-model="petition.petitionerQuestInfo.jobTitle"
                            :tplsection="'petitionerQuestInfo'" :tplkey="'jobTitle'" :fieldName="'jobTitle'" :required="false"
                            label="Job Title" placeHolder="Job Title" />
                            
                            <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'itineraryPeti','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'itineraryPeti'"
                            :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="itineraryPeti"  v-model="petition.petitionerQuestInfo.itineraryPeti" :tplsection="'petitionerQuestInfo'"  :fieldName="'itineraryPeti'"  label="Did you include an itinerary with the petition?"></immiyesorno>
                           
                            <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'everBenfWorkOffSiteAnothComp','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'everBenfWorkOffSiteAnothComp'"
                            :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="everBenfWorkOffSiteAnothComp"  v-model="petition.petitionerQuestInfo.everBenfWorkOffSiteAnothComp" :tplsection="'petitionerQuestInfo'"  :fieldName="'everBenfWorkOffSiteAnothComp'"  label="Will the beneficiary(ies) work for you offsite at another company or organization's location?"></immiyesorno>
                            
                            <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'everBenfExcluCommonOrNorthIslands','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'everBenfExcluCommonOrNorthIslands'"
                            :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="everBenfExcluCommonOrNorthIslands"  v-model="petition.petitionerQuestInfo.everBenfExcluCommonOrNorthIslands" :tplsection="'petitionerQuestInfo'"  :fieldName="'everBenfExcluCommonOrNorthIslands'"  label="Will the beneficiary(ies) work exclusively in the Commonwealth of the Northern Mariana Islands (CNMI)?"></immiyesorno>
                            
                            <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'fullTimePosition','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'fullTimePosition'"
                            :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="fullTimePosition"  v-model="petition.petitionerQuestInfo.fullTimePosition" :tplsection="'petitionerQuestInfo'"  :fieldName="'fullTimePosition'"  label="Is this a full-time position?"></immiyesorno>
                            
                            <immiInput v-if="checkProperty(petition, 'petitionerQuestInfo', 'fullTimePosition') == false" :display="false" :fieldsArray="questionnaireDetails" cid="hoursPerWeek" :onlyNumbers="true"
                            formscope="casedetailsform" v-model="petition.petitionerQuestInfo.hoursPerWeek" :maxvalueData="'maxval:168'"
                            :tplsection="'petitionerQuestInfo'" :tplkey="'hoursPerWeek'" :fieldName="'hoursPerWeek'" :required="false"
                            label="How many hours per week for the position?" placeHolder="How many hours per week for the position?" />
                            
                            <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="salary" :maxLength="10"
                            formscope="casedetailsform" v-model="petition.petitionerQuestInfo.salary" :onlyNumbers="true"
                            :tplsection="'petitionerQuestInfo'" :tplkey="'salary'" :fieldName="'salary'" :required="false"
                            label="Wages" placeHolder="Wages" />
                            
                            <selectField :display="false" :tplkey="'payFrequency'" :tplsection="'petitionerQuestInfo'" :listContainsId="false" :fieldsArray="questionnaireDetails" 
                            :required="true" :optionslist="petition.payFrequencyList" v-model="petition.petitionerQuestInfo.payFrequency" :formscope="'casedetailsform'" 
                            fieldName="payFrequency" label="Pay Terms" placeHolder="Pay Terms" />
                            
                            <div class="vx-col w-full  ownership_editor" v-if="canRenderField('otherCompensation',questionnaireDetails,false ,'petitionerQuestInfo')">
                                <div class="form_group">
                                    <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.petitionerQuestInfo.otherCompensation" :tplsection="'petitionerQuestInfo'" :tplkey="'otherCompensation'" :fieldName="'otherCompensation'"  :required="true"  :customValidNotRequire="true" 
                                    label="Other Compensation" placeHolder="Other Compensation"  :canSpellCheck="true"/>
                                </div>
                            </div>
                           
                            <datepickerField @input="clearDependentField()"  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfIntendedEmpFrom'"  :validationRequired="true" 
                            v-model="petition.petitionerQuestInfo.dateOfIntendedEmpFrom" formscope="casedetailsform" :dateEnableTo="featureDates"  
                            :tplsection="'petitionerQuestInfo'"  :fieldName="'dateOfIntendedEmpFrom'" :cid="'dateOfIntendedEmpFrom'"  label="Dates of intended employment from" />
                            
                            <datepickerField :isDisabled="!petition.petitionerQuestInfo.dateOfIntendedEmpFrom"  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfIntendedEmpTo'"  :validationRequired="true" 
                            v-model="petition.petitionerQuestInfo.dateOfIntendedEmpTo" formscope="casedetailsform" :dateEnableTo="featureDates"  :dateEnableFrom="petition.petitionerQuestInfo.dateOfIntendedEmpFrom"
                            :tplsection="'petitionerQuestInfo'"  :fieldName="'dateOfIntendedEmpTo'" :cid="'dateOfIntendedEmpTo'"  label="Dates of intended employment to" />
                            
                            <div class="vx-col w-full" v-if="canRenderField('workAddress',questionnaireDetails, false, 'petitionerQuestInfo' )">
                                <template v-if="usCountry.length>0">
                                    <div v-if="canRenderField('workAddress',questionnaireDetails, false, 'petitionerQuestInfo' )">
                                        <h3 class="small-header">Work Address</h3>
                                        <addressField :disableCountry="checkProperty(petition.petitionerQuestInfo, 'workAddress') && checkProperty(petition.petitionerQuestInfo, 'workAddress', 'countryDetails') && checkProperty(petition.petitionerQuestInfo.workAddress, 'countryDetails', 'id') == 231"
                                        :fieldsArray="questionnaireDetails" formscope="casedetailsform" :showaptType="true" 
                                        :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'workAddress','section':'petitionerQuestInfo', 'fieldsArray':questionnaireDetails, 'required':true })"
                                        :countries="usCountry" v-model="petition.petitionerQuestInfo.workAddress" :tplsection="'petitionerQuestInfo'"  :fieldName="'workAddress'"  :cid="'petitionerQuestInfoworkAddress'" />
                                    </div>
                                </template>
                            </div>


                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div v-if="currentTab=='documents'" id="documents_details">
                  <form data-vv-scope="documentsform" @submit.prevent="" @keydown.enter.prevent="">
                    <vs-col class="w-full p-0">
                      <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                        NOTE: This questionnaire should be filled out completely and
                        accurately. Kindly read the instructions carefully.
                      </vs-alert>
                    </vs-col>
                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                      <div class="form-container form-container-questionnaire">
                        <div class="vx-row">
                        <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'usaCompanyDocumentslist'" :docslist="usaCompanyDocumentslist" :petition="petition" :formscope="'documentsform'" :fieldsArray="questionnaireDetails" v-model="petition.petitionerQuestInfo.usaCompanyDocuments" :tplsection="'petitionerQuestInfo.usaCompanyDocuments'"  :fieldName="'usaCompanyDocuments'" :title="'USA Company Documents'" ></casedocumentslist>
                      </div>
                      </div>
                    </vs-col>
                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                      <div class="form-container  form-container-questionnaire">
                        <div class="vx-row">
                         <casedocumentslist @emitUploadingAction="emitUploadingAction"  :docMainCategory="'foreignCompanyDocumentsList'" :docslist="foreignCompanyDocumentsList" :petition="petition" :formscope="'documentsform'" :fieldsArray="questionnaireDetails" v-model="petition.petitionerQuestInfo.foreignCompanyDocuments" :tplsection="'petitionerQuestInfo.foreignCompanyDocuments'"  :fieldName="'foreignCompanyDocuments'" :title="'Foreign Company Documents'"></casedocumentslist>
                       </div>
                      </div>
                    </vs-col>

                  </form>
                </div>
                <!-- && consentData && termsAndConditionsData -->
                <div v-if="['Update', 'Review & Submit', 'Submit'].indexOf(actiontype)>-1 && [50,51].indexOf(getUserRoleId)>-1&&checkProperty(configDetails ,'acceptConsentAndTAndC')!=false">
                    <form data-vv-scope="consentTermsForm" @submit.prevent="" @keydown.enter.prevent="">
                        <div class="m-auto float-none" :class="{'pl-5':currentTab != 'documents'}" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                            <div class="form-container pt-0 form-container-questionnaire">
                                <div class="vx-row">
                                    <div class="vx-col w-full">
                                        <label class="switch-label"> <span @click="openConsentContent('termsAndConditions')" class="terms_n_cond_lbl">Terms and Conditions</span> and <span @click="openConsentContent('consent')" class="terms_n_cond_lbl">Consent </span>to the collection and processing of my personal data for immigration case(s), including any applicable necessary filings.</label>
                                    </div>
                                    <div class="vs-col">
                                        <div class="form_group custom-form-label custom-cx-box">
                                            <vs-checkbox
                                            v-model="consentChecked"
                                            data-vv-as="adjustmentOfI485Status"
                                            name="consentChecked">I have read and understand the above
                                            </vs-checkbox>
                                        </div>
                                        <input type="hidden" :name="'select_PrimaryH1BHolder'" v-validate="'required'" data-vv-as="Field"
                                        v-model="getConsentVal">
                                        <span class="text-danger text-sm pt-5" style="top:46px"
                                        v-show="errors.has('consentTermsForm.select_PrimaryH1BHolder')">*You must read and understand the above</span>
                                    </div>
                                    <div class="vs-col">
                                        <div class="form_group custom-form-label custom-cx-box">
                                            <vs-checkbox
                                            v-model="termsAndConditionsChecked"
                                            data-vv-as="adjustmentOfI485Status"
                                            name="termsAndConditionsChecked">I agree to the above
                                            </vs-checkbox>
                                        </div>
                                        <input type="hidden" :name="'select_PrimaryH1BHoer'" v-validate="'required'" data-vv-as="Field"
                                        v-model="getTermsVal">
                                        <span class="text-danger text-sm pt-5" style="top:46px"
                                        v-show="errors.has('consentTermsForm.select_PrimaryH1BHoer')">*You must agree to the above</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
              </div>
            </div>
            <div class="questionnaire_footer">
              <div class="d-flex">
                <vs-button v-if="checkActiveTab == 1"   @click="goBack()" class="questionnaire_btn"
                  type="filled">Back</vs-button>
              </div>
              <div class="d-flex">
                <vs-button  :disabled="documentUploading" @click="saveCase(true, true, false);" class="questionnaire_btn" type="filled">Save</vs-button>
                <vs-button  :disabled="documentUploading" color="success" @click="submitCase();" class="save questionnaire_btn" type="filled">{{actiontype}}</vs-button>
  
              </div>
            </div>
          </div>
        </div>
        <div class="custom_modal_sec preview_questionarie" :class="{ modalopen: questionnairePreview }">
            <div class="custom_modal_overlay" ></div>
            <div class="custom_modal_cnt">
                <div class="modal_title">
                    <h2>Questionnaire Review</h2>
                    <span @click="questionnairePreview = false">
                        <x-icon size="1.5x" class="close"></x-icon>
                    </span>
                </div>
                <div class="modal_cnt preview_content new_questionnaire_review">
                    <VuePerfectScrollbar ref="mainSidebarPs1" :settings="settings">
                        <PetitionDetails :callfromPetitionerPrefill="true" v-if="questionnairePreview" :loadedFromPreview="true" :fieldsArrayDetails="questionnaireDetails" :previewData="questionnairePreviewData" />
                    </VuePerfectScrollbar>
                </div>
                <div class="questionnaire_footer">
                    <div class="d-flex">
                        <vs-button @click="questionnairePreview = false" class="cancel questionnaire_btn" type="filled">Cancel
                        </vs-button>
                        <vs-button  @click="saveCase(false,false);" class="save questionnaire_btn" type="filled">Submit </vs-button>
                        <vs-button v-if="false"  @click="tempSave =false;showMessage = false; tempSave =false;showMessage = false; toggleBenProfileCOnformPopUp(true)" class="save questionnaire_btn" type="filled">Submit </vs-button>
                    </div>
                </div>
            </div>
        </div>
        <vs-popup class="holamundo success-popups cls-btn" title="Your registration is complete." v-if="SuccessQuestionnaire" :active.sync="SuccessQuestionnaire">
            <form  @submit.prevent="" @keydown.enter.prevent="">
                <div class="form-container" @click="formerrors.msg = ''">
                    <figure>
                        <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
                    </figure>
                    <h2 class="title">Questionnaire submitted successfully!</h2> 
                    <template v-if="checkProperty($route ,'name') !='fill-Petitioner-questionnaire' && checkProperty($route ,'name') !='fill-questionnaire' && checkProperty($route ,'name') !='fill-perm-questionnaire' ">
                        <p v-if="getUserData && checkProperty(getUserData['tenantDetails']['typeDetails'],'id') == 2">
                            It will be reviewed by the Admin and appropriate actions will be
                            taken soon. 
                        </p>
                        <p v-if="getUserData && (checkProperty(getUserData['tenantDetails']['typeDetails'],'id') == 1)">
                            It will be reviewed by the petitioner and appropriate actions will be
                            taken soon. 
                        </p>
                        <p>
                        Continue to fill Beneficiary Questionnaire. 
                        </p>
                    </template>
                </div>
                <div class="popup-footer">

                    <vs-button color="dark" @click="reloadthePage(false)" class="cancel" type="filled">cancel</vs-button>
                    <vs-button color="success" v-if="checkProperty($route ,'name') !='fill-Petitioner-questionnaire'" @click="reloadthePage(true)" class="save" type="filled">continue</vs-button>
                </div>
            </form>
        </vs-popup>
        <vs-popup class="holamundo main-popup cls-btn" title="Case Details" :active.sync="showPrefillPopup">
            <div class="form-container"> 
                <div class="vx-row">
                    <div class="vx-col w-full" v-if="beneFiciaryDeytailsExists">
                        <p style="line-height: 20px">
                            Do you want to pre-fill the basic information from the Beneficiary Profile?
                        </p>
                    </div>
                    <div class="vx-col w-full" v-else>
                        <p style="line-height: 20px">
                            Do you want to pre-fill the basic information from the previous
                            case details?
                        </p>
                    </div>
                </div>
            </div>
            <!-- setBasicData(); -->
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="showPrefillPopup = false">Cancel</vs-button>
                <vs-button color="success" class="save" type="filled" @click="
                prefilltheDetails();prefillAction = true;
                showPrefillPopup = false;
              ">Yes</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="holamundo main-popup cls-btn" title="Confirmation" :active.sync="showBenProfileSyncPopup">
            <div class="form-container">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <p style="line-height: 20px">
                            Do you want to update the Beneficiary Profile with the new/change information entered in this case?
                        </p>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="conformBenProfile(false)">Cancel</vs-button>
                <vs-button @click="conformBenProfile(true);" class="save questionnaire_btn" type="filled">Yes </vs-button>
            </div>
        </vs-popup>
        <template v-if="!checkCurrentUrl">
            <generatePin v-if="openGeneratePinPopUp" 
            @updateVerificationStatus="updateVerificationStatus"
            @hideMe="openGeneratePinPopUp = false"  
            :callFromPetitoner="true"
            :petitionDetails="petition" />
        </template>
        <modal
        name="showConsentContentPopup"
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="600px"
        height="auto"
        >
            <div class="v-modal profile_details_modal terms_n_conditions">
            <div class="popup-header fromDetailsPage">
                <h2 class="popup-title">{{getLabelContent}}</h2>
                <span  @click="$modal.hide('showConsentContentPopup')">
                <em class="material-icons">close</em>
                </span>
            </div>

            <div class="form-container"> 
                <div class="vx-row">
                    <div class="vx-col w-full" v-if="contentCategory == 'consent'">
                        <p class="ownership_details" v-html="consentData" ></p>
                    </div>
                    <div class="vx-col w-full" v-if="contentCategory == 'termsAndConditions'">
                        <p class="ownership_details" v-html="termsAndConditionsData" ></p>
                    </div>
                </div>
            </div>
            <!-- ;agreeTerms(contentCategory) -->
            <div class="popup-footer relative">
                <vs-button color="success"
                    @click="$modal.hide('showConsentContentPopup')"
                    class="save"
                    type="filled"
                    >Okay
                </vs-button>
            </div>

            </div>
        </modal>
      </div>
    </span>
  </template>
  
  <script>
    import Vue from 'vue';
    import generatePin from "@/views/actionpopups/generatePin.vue";
  //import petitionform from "./forms/petition.vue";
  //import petitionform from "./forms/case.vue";
  //import gcform from "./forms/gcform.vue";
  import { XIcon } from "vue-feather-icons";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import JQuery from 'jquery';
  import PetitionDetails from "@/views/PetitionDetails.vue";
  import moment from "moment";
  import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
  import educationsList from "@/views/forms/fields/educationsList.vue";
  import immieducations from "@/views/forms/fields/educations.vue";
  import immipriorstay from "@/views/forms/fields/priorstay.vue";
  import immiyesorno from "@/views/forms/fields/yesorno.vue";
  import addressField from "@/views/forms/fields/address.vue";
  import immiMask from "@/views/forms/fields/maskinput.vue";
  import selectField from "@/views/forms/fields/simpleselect.vue";
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  import immiPhone from "@/views/forms/fields/phonenumber.vue";
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import genderField from '@/views/forms/fields/gender.vue'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import PhoneMaskInput from "vue-phone-mask-input";
  import { TheMask } from 'vue-the-mask';
  import casedocumentslist from "@/views/common/casedocuments.vue";
  import { InfoIcon } from "vue-feather-icons";
    import { EyeIcon } from "vue-feather-icons";
    import childpersonalinfo from "@/views/forms/fields/childpersonalinfo.vue";
    import fileUploadNote from "@/views/common/fileUploadNote.vue";
    import quillTextEditor from "./fields/quillTextEditor.vue";
  export default {
    provide() {
      return {
        parentValidator: this.$validator,
      };
    },
    components: {
        generatePin,
        quillTextEditor,
      fileUploadNote,
      childpersonalinfo,
      InfoIcon,
      EyeIcon,
      casedocumentslist,
      VuePerfectScrollbar,
      XIcon,
      PetitionDetails,
      immiswitchyesno,
      educationsList,
      immieducations,
      immipriorstay,
      immiyesorno,
      addressField,
      immiMask,
      selectField,
      datepickerField,
      immiPhone,
      immiInput,
      DatePicker,
      PhoneMaskInput,
      TheMask,
      genderField,
    },
    data: function () {
      return {
        configDetails:null,
        consentData:'',
        termsAndConditionsData:'',
        contentCategory:'',
        consentTermsAndCondition:false, 
        termsAndConditionsChecked:false, 
        consentChecked:false,
        // Consent End
        openGeneratePinPopUp:false,
        childdoclist: 
          [
            {
                required: false,
                key: 'child_docs_passport',
                fieldName: 'passport',
                label: 'Passport- First page with photo, Visa page and last page with address'
            }, {
                required: false,
                key: 'child_docs_visa',
                fieldName: 'visa',
                label: 'Visa'
            },
            {
                required: false,
                key: 'child_docs_form_i94',
                fieldName: 'formI94',
                label: 'I94'
            },
            {
                required: false,
                key: 'child_docs_approval_notice',
                fieldName: 'approvalNotice',
                label: 'Approval Notice'
            },
            {
                required: false,
                key: 'child_docs_birth_certificate',
                fieldName: 'birthCertificate',
                label: 'Birth Certificate'
            },
            {
                required: false,
                fieldName: 'slgApprovalNoticeOfPrevH4',
                "key": "child_docs_slgApprovalNoticeOfPrevH4",
                "label": "Current and Previous H4 Approval Copies"
            },
            {
                required: false,
                key: 'child_docs_other',
                fieldName: 'other',
                label: 'Others'
            }
        ],
        selectedchild: 0,
        hasRequiredForChildren: false,
        spouseModalForm: false,
        childModalForm: false,
        showBenProfileSyncPopup:false,
        tempSave:false,
        showMessage:true,
        benProfileDetails:null,
        beneFiciaryDeytailsExists:false,
        usastates: [],
        documentUploading:false,
        usaCompanyDocumentslist:[
            {
                required: false,
                fileUploading:false,
                key:'incorporationCertDocs',
                fieldName:"incorporationCertDocs",
                label:'Certificate of Incorporation'
            },
            {
                required: false,
                fileUploading:false,
                key:'amendmentCertDocs',
                fieldName:"amendmentCertDocs",
                label:'Certificate of Amendment of Certificate of Incorporation'
            },
            {
                required: false,
                fileUploading:false,
                key:'stockCopyCertDocs',
                label:'Copy of stock certificates',
                fieldName:"stockCopyCertDocs",
            },
            {
                required: false,
                fileUploading:false,
                key: 'curOrgaChart',
                fieldName: 'curOrgaChart',
                label: 'Current Organizational Chart '
            },  
            {
                required: false,
                fileUploading:false,
                key: 'minOfBoardMeetings',
                fieldName: 'minOfBoardMeetings',
                label: 'Minutes of Board Meetings'
            }, 
            
            {
                required: false,
                fileUploading:false,
                key: 'contraExecOfCopyDocs',
                fieldName: 'contraExecOfCopyDocs',
                label: 'Copy of the contracts executed'
            }, 
            
            {
                required: false,
                fileUploading:false,
                key: 'auditFinaStatMostRecent',
                fieldName: 'auditFinaStatMostRecent',
                label: 'Most recent audited financial statements or Federal Tax Returns'
            },
            {
                required: false,
                fileUploading:false,
                key: 'productDocs',
                fieldName: 'productDocs',
                label: 'Product Documents '
            }   
        ],
        foreignCompanyDocumentsList:[
            {
                required: false,
                key: 'taxReturns',
                cid:'taxReturns',
                fieldName: 'taxReturns',
                label: 'Income tax Returns'
            },
            {
                required: false,
                fileUploading:false,
                key: 'bankStatements',
                fieldName: 'bankStatements',
                cid: 'bankStatements',
                label: 'Bank Statements'
            }, 
            {
                required: false,
                fileUploading:false,
                key: 'verifyOrSupportLetter',
                fieldName: 'verifyOrSupportLetter',
                cid: 'verifyOrSupportLetter',
                label: 'Verification/Support Letter'
            }, 
            {
                required: false,
                fileUploading:false,
                key: 'orgnaStructureDocs',
                fieldName: 'orgnaStructureDocs',
                cid: 'orgnaStructureDocs',
                label: 'Organization Structure'
            }, 
            {
                required: false,
                fileUploading:false,
                key: 'proAndLossStatDocs',
                cid: 'proAndLossStatDocs',
                fieldName: 'proAndLossStatDocs',
                label: 'Profit and Loss Statements of Foreign Company'
            },  
        ],
        questionnaireLoader: false,
        petitionLoaded: false,
        settings: {},
        SuccessQuestionnaire: false,
        showPrefillPopup: false,
        petition: null,
        featureDates: null,
        startEligibleDate: new Date().setFullYear(new Date().getFullYear() - 18),
        bfeprovinceStates: [],
        countries: [],
        usCountry:[],
        countriesWithoutUS:[],
        marital_statuses:[],
        questionnaireDetails: null,
        petitionId: "",
        userName: "",
        typeName: "",
        subTypeName: "",
        temp_save: false,
        action: "", // BENEFICIARY_INFO_UPDATE /
        questionnaireFilled: true,// Set true when submit questionnaire
        questionnaireUpdate: true, // Set true when you are updating questionnaire
        visastatuses: [],
        ignoreItems:['dateOfBenfEmployment', 'desPerStockOwnerShip', 'usaCompanyDocuments', 'foreignCompanyDocuments'],
        // ignoreItems:['countryOfBirth','countryOfBirthDetails','passportIssuedCountryDetails','passportIssuedCountry','maritalStatusDetails','maritalStatus','stateDetailsOfLastEntryInUS','stateOfLastEntryInUS',
        // 'curNonImmigrantVisaStatusDetails','curNonImmigrantVisaStatus','homePhoneCountryCode','homePhoneNumber','cellPhoneNumber','cellPhoneCountryCode','mailingAddressIsSameAsAddress'],
        detailsItemsList:[
          {
            key:'countryOfBirth',
            detailsKey:'countryOfBirthDetails',
            section:'petitionerQuestInfo',
            type:'details'
          },
          {
            key:'passportIssuedCountry',
            detailsKey:'passportIssuedCountryDetails',
            section:'petitionerQuestInfo',
            type:'details'
          },
          {
            key:'maritalStatus',
            detailsKey:'maritalStatusDetails',
            section:'petitionerQuestInfo',
            type:'details'
          },
          {
            key:'stateOfLastEntryInUS',
            detailsKey:'stateDetailsOfLastEntryInUS',
            section:'petitionerQuestInfo',
            type:'details'
          },
          {
            key:'curNonImmigrantVisaStatus',
            detailsKey:'curNonImmigrantVisaStatusDetails',
            section:'petitionerQuestInfo',
            type:'details'
          },
          {
            key:'cellPhoneNumber',
            detailsKey:'cellPhoneCountryCode',
            section:'petitionerQuestInfo',
            type:'phone'
          },
          {
            key:'homePhoneNumber',
            detailsKey:'homePhoneCountryCode',
            section:'petitionerQuestInfo',
            type:'phone'
          },
        ],
        tempPetition:  {
            petitionerQuestInfo: {
                benfComeToUSOpenNewOffice:null,
            classificationScougt: '', //Classification sought "L-1A or L-1B"
            nameOfEmpAbroad:  '', //Name of Employer Abroad  "Ideatech"
            address: {
                line1: null,
                line2: null,
                aptType: null,
                locationId: null,
                locationDetails: null,
                stateId: null,
                stateDetails: null,
                countryId: null,
                countryDetails: null,
              zipcode: null
            },   // Address of Employer Abroad
    dateOfBenfEmployment: [{ // 4. Dates of beneficiary's employment with this employer. Explain any interruptions in employment
        explaOfInterruptions: '',
        dateOfEmpFrom: '',
        dateOfEmpTo: ''
    }],
    descBenfDutAbroad3Years: '', // 5.Describe the beneficiary's duties abroad for the 3 years preceding the filing of the petition
    descBenfPropDutiesInUs: '', // 6.Describe the beneficiary's proposed duties in the United States.
    sumBenfEduAndWorkExp: '', //7.Summarize the beneficiary's education and work experience.
            companyRelaToAbroad:  '', // 8.How is the U.S. company related to the company abroad? Ex: "Parent/Branch/Subsidiary/Affiliate/Joint Venture"
            desPerStockOwnerShip: [{ // Describe the percentage of stock ownership and managerial control of each company that has a qualifying relationship. Provide the Federal Employer Identification Number for each U.S. company that has a qualifying relationship.
                perOfCompany: '',
                fedEmpIdentification: ''
            }],
            everqualRelaOneYearEmpl: null, // 10. Do the companies currently have the same qualifying relationship as they did during the one-year period of the beneficiary's employment with the company abroad? "Yes or No"
            everqualRelaOneYearEmplExpla: '', // If No need explanation
            benePriOffsiteEmp: null, // Will the beneficiary be stationed primarily offsite (at the worksite of an employer other than the petitioner or its affiliate, subsidiary, or parent)?
            priOffsiteEmpExpla: '', // 13.b
            priReasplaceToAnotWorksite: '', // 13.c
            usaCompanyDocuments: {
                incorporationCertDocs: [],  // Certificate of Incorporation
                amendmentCertDocs: [], // Certificate of Amendment of Certificate of Incorporation
                stockCopyCertDocs: [], // Copy of stock certificates
                leaAgreeForPropOffice: [], // Lease Agreements for the proposed office (only for L1A and to open new office)
                curOrgaChart: [], // Current Organizational Chart
                propOrgaChart: [], // Proposed Organizational Chart (only for L1A and to open new office)
                l1AVisaBusiPlan: [], //L1-A Visa Business Plan (only for L1A and to open new office)
                minOfBoardMeetings: [], // Minutes of Board Meetings (optional)
                contraExecOfCopyDocs: [], // Copy of the contracts executed (optional)
                auditFinaStatMostRecent: [], // Most recent audited financial statements or Federal Tax Returns
                bankIndicAndBal: [], // Letter from bank indicating status and balance (only for L1A and to open new office)
                productDocs: [], // Product Documents (Only for L1B) optional
            },
            foreignCompanyDocuments: {
                taxReturns: [], // Income tax Returns
                bankStatements: [], // Bank Statements
                verifyOrSupportLetter: [], // Verification/Support Letter
                orgnaStructureDocs: [], //Organization Structure
                proAndLossStatDocs: [] // Profit and Loss Statements of Foreign Company
            }
            }
        },
        petition: {
            payFrequencyList: ["Hour", "Week", "Month", "Year"],
            companyRelationList:['Parent', 'Branch', 'Subsidiary', 'Affiliate', 'Joint Venture' ],
            petitionerQuestInfo: { 
                benfComeToUSOpenNewOffice:null,
            classificationScougt: '', //Classification sought "L-1A or L-1B"
            nameOfEmpAbroad:  '', //Name of Employer Abroad  "Ideatech"
            address: {
                line1: null,
                line2: null,
                aptType: null,
                locationId: null,
                locationDetails: null,
                stateId: null,
                stateDetails: null,
                countryId: null,
                countryDetails: null,
              zipcode: null
            },   // Address of Employer Abroad
    dateOfBenfEmployment: [{ // 4. Dates of beneficiary's employment with this employer. Explain any interruptions in employment
        explaOfInterruptions: '',
        dateOfEmpFrom: '',
        dateOfEmpTo: ''
    }],
    descBenfDutAbroad3Years: '', // 5.Describe the beneficiary's duties abroad for the 3 years preceding the filing of the petition
    descBenfPropDutiesInUs: '', // 6.Describe the beneficiary's proposed duties in the United States.
    sumBenfEduAndWorkExp: '', //7.Summarize the beneficiary's education and work experience.
            companyRelaToAbroad:  '', // 8.How is the U.S. company related to the company abroad? Ex: "Parent/Branch/Subsidiary/Affiliate/Joint Venture"
            desPerStockOwnerShip: [{ // Describe the percentage of stock ownership and managerial control of each company that has a qualifying relationship. Provide the Federal Employer Identification Number for each U.S. company that has a qualifying relationship.
                perOfCompany: '',
                fedEmpIdentification: ''
            }],
            everqualRelaOneYearEmpl: null, // 10. Do the companies currently have the same qualifying relationship as they did during the one-year period of the beneficiary's employment with the company abroad? "Yes or No"
            everqualRelaOneYearEmplExpla: '', // If No need explanation
            benePriOffsiteEmp: null, // Will the beneficiary be stationed primarily offsite (at the worksite of an employer other than the petitioner or its affiliate, subsidiary, or parent)?
            priOffsiteEmpExpla: '', // 13.b
            priReasplaceToAnotWorksite: '', // 13.c
            jobTitle: '', // Job Title  
            workAddress: {
                line1: null,
                line2: null,
                aptType: null,
                locationId: null,
                locationDetails: null,
                stateId: null,
                stateDetails: null,
                countryId: 231, 
                countryDetails: { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" },
                // countryId: null,
                // countryDetails: null,
              zipcode: null
            }, // Work Address
            itineraryPeti: null, // Did you include an itinerary with the petition? Ex: Yes or No
            everBenfWorkOffSiteAnothComp: null,// Will the beneficiary(ies) work for you off-site at another company or organization's location? Ex: Yes or No
            everBenfExcluCommonOrNorthIslands: null, // Will the beneficiary(ies) work exclusively in the Commonwealth of the Northern Mariana Islands (CNMI)?  Ex: Yes or No
            fullTimePosition:  null, //Is this a full-time position?
            hoursPerWeek: null,  // How many hours per week for the position?
            salary: '', // wages Ex: "$5,000,000"
            payFrequency: '', // Pay Terms Ex: Hour/Week/Month/Year
            otherCompensation: '', // Other Compensation
            dateOfIntendedEmpFrom: null,
            dateOfIntendedEmpTo: null,
            usaCompanyDocuments: {
                incorporationCertDocs: [],  // Certificate of Incorporation
                amendmentCertDocs: [], // Certificate of Amendment of Certificate of Incorporation
                stockCopyCertDocs: [], // Copy of stock certificates
                leaAgreeForPropOffice: [], // Lease Agreements for the proposed office (only for L1A and to open new office)
                curOrgaChart: [], // Current Organizational Chart
                propOrgaChart: [], // Proposed Organizational Chart (only for L1A and to open new office)
                l1AVisaBusiPlan: [], //L1-A Visa Business Plan (only for L1A and to open new office)
                minOfBoardMeetings: [], // Minutes of Board Meetings (optional)
                contraExecOfCopyDocs: [], // Copy of the contracts executed (optional)
                auditFinaStatMostRecent: [], // Most recent audited financial statements or Federal Tax Returns
                bankIndicAndBal: [], // Letter from bank indicating status and balance (only for L1A and to open new office)
                productDocs: [], // Product Documents (Only for L1B) optional
            },
            foreignCompanyDocuments: {
                taxReturns: [], // Income tax Returns
                bankStatements: [], // Bank Statements
                verifyOrSupportLetter: [], // Verification/Support Letter
                orgnaStructureDocs: [], //Organization Structure
                proAndLossStatDocs: [] // Profit and Loss Statements of Foreign Company
            }
            }
        },
        questionnairePreview: false,
        questionnairePreviewData: null,
        education_types: [],
        showPrefillPopup: false,
        latestPetition: null,
        questionnaireTplType: 'general',
        currentTab: 'casedetails',
        tabslist: [
          {
            key: "casedetails",
            name: "Personal Info"
          },
          {
            key: "documents",
            name: "Documents"
          }
        ],
        tabName: 'PersonalInfo',
        showsideModal: false,
      }
    },
    methods: { 
        agreeTerms(categ){
                if(categ == 'consent'){
                    this.consentChecked=true;
                }
                if(categ == 'termsAndConditions'){
                    this.termsAndConditionsChecked=true
                }
                this.$modal.hide('showConsentContentPopup');
            },
            getGlobalConfigDetails(){
                let postData ={}
                let path = 'global-config/details'
                this.$store.dispatch("commonAction", {data:postData,path:path})
                .then((response) =>{   
                    if(this.checkProperty(response ,"config" )){
                        this.configDetails = this.checkProperty(response ,"config" );
                    }
                })
            },
            getConsentDetails(){
                let path = '/global/get-consent-content';
                let payLoad = {
                    tenantId:this.checkProperty( this.getUserData, 'tenantId')
                };
                this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
                    if(res){
                        if(res['consent']){
                            this.consentData = res['consent'];
                        }
                        if(res['termsAndConditions']){
                            this.termsAndConditionsData = res['termsAndConditions'];
                        }
                    }
                }).catch((err)=>{

                })
            },
            openConsentContent(category){
                this.getConsentDetails();
                let self = this;
                setTimeout(()=>{
                    self.contentCategory = category;
                    self.$modal.show('showConsentContentPopup')
                }, 1000)
                
                // this.showConsentContentPopup = true;
            },
        updateVerificationStatus(status=false){
            this.openGeneratePinPopUp =false;
            this.tokenVerified = status;
            this.init();
        },
        conditionalBasis(){
            this.clearExplanation();
            this.clearOffsiteLocation();
        },
        clearExplanation(){
            if(this.checkProperty(this.petition, 'petitionerQuestInfo', 'everqualRelaOneYearEmpl') != false){
                this.petition.petitionerQuestInfo.everqualRelaOneYearEmplExpla = '';
            }
        },
        clearOffsiteLocation(){
            if(this.checkProperty(this.petition, 'petitionerQuestInfo', 'benePriOffsiteEmp') != true){
                this.petition.petitionerQuestInfo.priOffsiteEmpExpla = '';
                this.petition.petitionerQuestInfo.priReasplaceToAnotWorksite ='';
            }
        },
        updateL1Docs(callFromSubmit = false){
            let docs =[
                {
                    required: false,
                    fileUploading:false,
                    key: 'leaAgreeForPropOffice',
                    fieldName: 'leaAgreeForPropOffice',
                    label: 'Lease Agreements for the proposed office'
                },
                {
                    required: false,
                    fileUploading:false,
                    key: 'propOrgaChart',
                    fieldName: 'propOrgaChart',
                    label: 'Proposed Organizational Chart'
                }, 
                {
                    required: false,
                    fileUploading:false,
                    key: 'l1AVisaBusiPlan',
                    fieldName: 'l1AVisaBusiPlan',
                    label: 'L1-A Visa Business Plan'
                }, 
                {
                    required: false,
                    fileUploading:false,
                    key: 'bankIndicAndBal',
                    fieldName: 'bankIndicAndBal',
                    label: 'Letter from bank indicating status and balance'
                },
            ]
            let list = _.cloneDeep(this.usaCompanyDocumentslist)
            if(this.checkProperty(this.petition, 'petitionerQuestInfo', 'benfComeToUSOpenNewOffice')){ 
               _.forEach(docs, (item)=>{
                let findObj = _.find(list, {'key':item['key']});
                if(!findObj){
                    list.push(item);
                }
               })
               this.usaCompanyDocumentslist = _.cloneDeep(list)
            }else{
                let tempList = [
                    {
                        required: false,
                        fileUploading:false,
                        key:'incorporationCertDocs',
                        fieldName:"incorporationCertDocs",
                        label:'Certificate of Incorporation'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key:'amendmentCertDocs',
                        fieldName:"amendmentCertDocs",
                        label:'Certificate of Amendment of Certificate of Incorporation'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key:'stockCopyCertDocs',
                        label:'Copy of stock certificates',
                        fieldName:"stockCopyCertDocs",
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'curOrgaChart',
                        fieldName: 'curOrgaChart',
                        label: 'Current Organizational Chart '
                    },  
                    {
                        required: false,
                        fileUploading:false,
                        key: 'minOfBoardMeetings',
                        fieldName: 'minOfBoardMeetings',
                        label: 'Minutes of Board Meetings'
                    }, 
                    
                    {
                        required: false,
                        fileUploading:false,
                        key: 'contraExecOfCopyDocs',
                        fieldName: 'contraExecOfCopyDocs',
                        label: 'Copy of the contracts executed'
                    }, 
                    
                    {
                        required: false,
                        fileUploading:false,
                        key: 'auditFinaStatMostRecent',
                        fieldName: 'auditFinaStatMostRecent',
                        label: 'Most recent audited financial statements or Federal Tax Returns'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'productDocs',
                        fieldName: 'productDocs',
                        label: 'Product Documents '
                    }   
                ]
                this.usaCompanyDocumentslist = _.cloneDeep(tempList);
                if(callFromSubmit){
                    this.petition['petitionerQuestInfo']['usaCompanyDocuments']['leaAgreeForPropOffice'] = [];
                    this.petition['petitionerQuestInfo']['usaCompanyDocuments']['propOrgaChart'] = [];
                    this.petition['petitionerQuestInfo']['usaCompanyDocuments']['l1AVisaBusiPlan'] = [];
                    this.petition['petitionerQuestInfo']['usaCompanyDocuments']['bankIndicAndBal'] = [];
                }
                
            }
        },
        removeStockOwner(ind){
            Vue.delete(this.petition.petitionerQuestInfo.desPerStockOwnerShip, ind); 
        },
        addStockOwner(){
            let obj = {
                perOfCompany: '',
                fedEmpIdentification: ''
            };
            this.petition.petitionerQuestInfo['desPerStockOwnerShip'].push(obj)
        },
        removeBenEmpDates(ind){
            Vue.delete(this.petition.petitionerQuestInfo.dateOfBenfEmployment, ind);
        },
        addBenEmpDates(){
            let obj = {
                explaOfInterruptions: '',
                dateOfEmpFrom: null,
                dateOfEmpTo: null
            };
            this.petition.petitionerQuestInfo['dateOfBenfEmployment'].push(obj)
        },
        clearStartandEnddate(val,key,inder,position){  
            if( this.petition.petitionerQuestInfo[key] && this.checkProperty(this.petition.petitionerQuestInfo[key],'length')>0){
                let startDate = moment(this.petition.petitionerQuestInfo[key][inder]['dateOfEmpFrom']);
                let endDate = moment(this.petition.petitionerQuestInfo[key][inder]['dateOfEmpTo']);
                if(!val && position == 'start'){
                    this.petition.petitionerQuestInfo[key][inder]['dateOfEmpTo'] = null
                }
                if(val && position == 'start' && ( startDate.isAfter(endDate , 'day'))){
                    this.petition.petitionerQuestInfo[key][inder]['dateOfEmpTo'] = null
                }
                if(position == 'end' && ( endDate.isBefore(startDate, 'day'))){
                    this.petition.petitionerQuestInfo[key][inder]['dateOfEmpFrom'] = null
                }
            }
        },
        clearDependentField(){   
            if(this.checkProperty(this.petition['petitionerQuestInfo'], 'dateOfIntendedEmpFrom')){
                let dateVal = moment(this.petition.petitionerQuestInfo.dateOfIntendedEmpFrom);
                let endDate= moment(this.petition['petitionerQuestInfo']['dateOfIntendedEmpTo'])
                if(dateVal.isAfter(endDate , 'day')){
                    this.petition['petitionerQuestInfo']['dateOfIntendedEmpTo'] = null
                }
            }else{
                this.petition['petitionerQuestInfo']['dateOfIntendedEmpTo'] = null
            }
            
        },
        clearH4eadFields(val){
            if(val == false){
            this.petition.petitionerQuestInfo.doYouAlreadyH4EAD = null;
            this.petition.petitionerQuestInfo.stateOfLastEntryInUS = null;
            this.petition.petitionerQuestInfo.stateDetailsOfLastEntryInUS = null;
            this.petition.petitionerQuestInfo.placeOfLastEntryInUS = null;
            this.petition.petitionerQuestInfo.lastArrivalDate = null;
            }
        },
        prepopulateQuestionnaire(tplsection='petitionerQuestInfo'){
            let questionnaireSection = tplsection;
            if(questionnaireSection == 'petitionerQuestInfo' ){ //_.has(this.latestPetition, questionnaireSection+'.'+key)
                _.forEach(this.petition[questionnaireSection], (item,key)=>{
                    if(this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.ignoreItems.indexOf(key)<=-1 && this.checkProperty(this.latestPetition, questionnaireSection)
                    && (this.checkProperty(this.latestPetition, questionnaireSection, key) || this.checkProperty(this.latestPetition, questionnaireSection, key) == true || this.checkProperty(this.latestPetition, questionnaireSection, key) == false) ){
                        this.petition[questionnaireSection][key] = _.cloneDeep(this.latestPetition[questionnaireSection][key]);
                    }
                })
            }
            if(questionnaireSection == 'dateOfBenfEmployment' ){
                if(this.canRenderField( 'dateOfBenfEmployment', this.questionnaireDetails ,false, 'petitionerQuestInfo.dateOfBenfEmployment')){
                    if(this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'dateOfBenfEmployment') && this.checkProperty(this.latestPetition['petitionerQuestInfo'], 'dateOfBenfEmployment', 'length')>0){
                        this.petition['petitionerQuestInfo']['dateOfBenfEmployment'] = _.cloneDeep(this.latestPetition['petitionerQuestInfo']['dateOfBenfEmployment']);
                    }else{ 
                        this.petition['petitionerQuestInfo']['dateOfBenfEmployment'] = [];
                        this.petition['petitionerQuestInfo']['dateOfBenfEmployment'].push(this.getBenfEmploymentObj())

                    }
                }
            }
            if(questionnaireSection == 'desPerStockOwnerShip' ){
                if(this.canRenderField( 'desPerStockOwnerShip', this.questionnaireDetails ,false, 'petitionerQuestInfo.desPerStockOwnerShip')){
                    if(this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'desPerStockOwnerShip') && this.checkProperty(this.latestPetition['petitionerQuestInfo'], 'desPerStockOwnerShip', 'length')>0){
                        this.petition['petitionerQuestInfo']['desPerStockOwnerShip'] = _.cloneDeep(this.latestPetition['petitionerQuestInfo']['desPerStockOwnerShip']);
                    }else{ 
                        this.petition['petitionerQuestInfo']['desPerStockOwnerShip'] = [];
                        this.petition['petitionerQuestInfo']['desPerStockOwnerShip'].push(this.getStockOwnerShipObj())

                    }
                }
            }
            if(questionnaireSection == 'usaCompanyDocuments'){
                _.forEach(this.petition['petitionerQuestInfo']['usaCompanyDocuments'], (item,key)=>{
                    if(this.canRenderField( key, this.questionnaireDetails ,false, 'petitionerQuestInfo.usaCompanyDocuments') && this.checkProperty(this.latestPetition, 'petitionerQuestInfo') 
                    && this.checkProperty(this.latestPetition['petitionerQuestInfo'], 'usaCompanyDocuments', key) && this.checkProperty(this.latestPetition['petitionerQuestInfo']['usaCompanyDocuments'], key, 'length')>0 ){
                        this.petition['petitionerQuestInfo']['usaCompanyDocuments'][key] = this.latestPetition['petitionerQuestInfo']['usaCompanyDocuments'][key]; ;
                    }else{
                        this.petition['petitionerQuestInfo']['usaCompanyDocuments'][key] = [];
                    }
                })
            }
            if(questionnaireSection == 'foreignCompanyDocuments'){
                _.forEach(this.petition['petitionerQuestInfo']['foreignCompanyDocuments'], (item,key)=>{
                    if(this.canRenderField( key, this.questionnaireDetails ,false, 'petitionerQuestInfo.foreignCompanyDocuments') && this.checkProperty(this.latestPetition, 'petitionerQuestInfo') 
                    && this.checkProperty(this.latestPetition['petitionerQuestInfo'], 'foreignCompanyDocuments', key) && this.checkProperty(this.latestPetition['petitionerQuestInfo']['foreignCompanyDocuments'], key, 'length')>0 ){
                        this.petition['petitionerQuestInfo']['foreignCompanyDocuments'][key] = this.latestPetition['petitionerQuestInfo']['foreignCompanyDocuments'][key]; ;
                    }else{
                        this.petition['petitionerQuestInfo']['foreignCompanyDocuments'][key] = [];
                    }
                })
            }
        },
        init(callFromMounted=false) {
            let _self = this;
            this.$store.dispatch("getcountries").then((response) => {
            this.countries = response;
            if(this.checkProperty(this.countries, 'length')>0){
                this.countriesWithoutUS = _.filter(this.countries,(item)=> {
                    return item.id != 231;
                });
                this.usCountry =_.filter(this.countries,(item)=> {
                    return item.id == 231;
                });
            }
            });
            this.petitionLoaded = false;
            this.$store.dispatch("getpetition", this.$route.params.itemId)
            .then((response) => {
            if(response && response.data && response.data.result){
                var data = _.merge(this.petition, response.data.result);      
                this.petition = data;
                let currentRoute = this.$route;
                let token = '';
                if(_.get(currentRoute, "name", "") == "fill-Petitioner-questionnaire" &&  _.has(currentRoute, "meta.getTokenFromUrl") && _.has(currentRoute, "query.token") ) {
                    token = _.get(currentRoute, "query.token", "");
                    if(token){
                        let payLoad = { apiToken:token };
                        let path = '/auth/verify-token';
                        this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((res)=>{
                            if(res){
                                this.$store.commit('updateAnonymousUserData', res)
                            }
                        }).catch((err)=>{})
                    }
                }
                this.getConsentDetails();
                let detailsFiled = false;
                 //pin verification functionality  
                 if(!this.checkCurrentUrl && callFromMounted &&  this.checkProperty( this.petition ,'requiredPinForQuesSubmit')  ){
                    // console.log('pinverification')
                    if(!this.openGeneratePinPopUp &&  this.checkProperty( this.petition ,'petitionerQstPinSet')){
                        if(!this.tokenVerified){
                            this.openGeneratePinPopUp =true;
                            return false;
                        }
                        
                        
                    }else{
                        this.openGeneratePinPopUp =true;
                        return false

                    }
                }
                if (this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length') >0 && this.checkProperty(this.petition, 'completedActivities').indexOf('SUBMIT_BY_PETITIONER') > -1 ){
                    detailsFiled = true;
                }
                if(detailsFiled && this.checkProperty(this.$route ,'name') =='fill-Petitioner-questionnaire'){
                    this.$router.push("/filled-case-details/" + this.$route.params.itemId+ "?token=" + token);
                }
                
                this.$store.dispatch("commonAction", { data: {questionnaireId: this.petition.questionnaireTplId},path: "/questionnaire/details",})
                .then((res) => {
                    let postData = {
                        userId: this.petition.userId,
                        getDocuments: true,
                        quesionnaireType : "Petitioner",
                        type: 5
                    };
                    let pth="petition/get-recent-by-beneficiary";
                    pth ="petition-common/get-recent-by-beneficiary";
                    
                    this.$store.dispatch("commonAction", {
                        data: postData,
                        path: pth,
                    })
                    .then((response) => {
                        let questFiled = false;
                        if(this.petition){
                            if(!this.checkProperty(this.petition, 'completedActivities')){
                                questFiled = true;
                            }else if (this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length') >0 && this.checkProperty(this.petition, 'completedActivities').indexOf('SUBMIT_BY_PETITIONER')<=-1 ){
                                questFiled = true;
                            }
                        }
                        if (false && response && response.profileDetails && response.profileDetails.petitionerQuestInfo  && this.checkProperty(response['profileDetails'],'petitionerQuestInfo','firstName')) {
                            if (!this.petition.questionnaireFilled && (this.petition.petitionerQuestInfo.email == null || this.petition.petitionerQuestInfo.email == '')) {
                                this.showPrefillPopup = true;
                            } 
                            this.beneFiciaryDeytailsExists  = true;
                            let tempDetails = response['profileDetails'];
                            this.latestPetition = tempDetails;
                        }
                        else if (response && response.caseDetails && response.caseDetails.petitionerQuestInfo) {
                            if (questFiled  && (this.petition.petitionerQuestInfo.nameOfEmpAbroad == null || this.petition.petitionerQuestInfo.nameOfEmpAbroad == '')) {
                                this.showPrefillPopup = true;
                            }
                            let tempDetails = response["caseDetails"];
                            this.latestPetition = tempDetails;
                            
                        }else if ( false && response && response.userDetails && response.userDetails && (!this.petition.questionnaireFilled && (this.petition.petitionerQuestInfo.email == null || this.petition.petitionerQuestInfo.email == ''))){

                            if(this.checkProperty(response ,'userDetails' ,'email' ) && !this.checkProperty(this.petition ,'petitionerQuestInfo' ,'email')){

                            this.petition['petitionerQuestInfo']['email'] = this.checkProperty(response ,'userDetails' ,'email' )


                            }
                            if(this.checkProperty(response ,'userDetails' ,'firstName' ) && !this.checkProperty(this.petition ,'petitionerQuestInfo' ,'firstName')){
                            this.petition['petitionerQuestInfo']['firstName'] = this.checkProperty(response ,'userDetails' ,'firstName' );
                            }
                            if(this.checkProperty(response ,'userDetails' ,'middleName' )  && !this.checkProperty(this.petition ,'petitionerQuestInfo' ,'middleName') ){
                                this.petition['petitionerQuestInfo']['firstName'] = this.checkProperty(response ,'userDetails' ,'middleName' );
                            }
                            if(this.checkProperty(response ,'userDetails' ,'lastName' ) && !this.checkProperty(this.petition ,'petitionerQuestInfo' ,'lastName') ){
                            this.petition['petitionerQuestInfo']['lastName'] = this.checkProperty(response ,'userDetails' ,'lastName' );
                            }
                            //this.removeFields()
                        }
                        this.questionnaireDetails = res.fields;
                        //this.questionnaireDetails = []
                        this.setTheInitData()
                    });
                })

            }else{
                this.$vs.loading.close();
            }
            })
        
            this.featureDates = new Date();
            setTimeout(()=>{
                this.$store.dispatch("getcountries").then((response) => {
                this.countries = response;
                if(this.checkProperty(this.countries, 'length')>0){
                    this.countriesWithoutUS = _.filter(this.countries,(item)=> {
                        return item.id != 231;
                    });
                    this.usCountry =_.filter(this.countries,(item)=> {
                        return item.id == 231;
                    });
                }
            });
            },100)
        },
        validateandScroll() {
            var $self = this;
            const $ = JQuery;
            var el = _.find(this.errors["items"], function (item) {
            return item.scope == $self.currentTab + "form"
            })
            if (el) {
            const ele = $("[name=" + el.field + "]").parents(".vx-col");
            var _top = 0;
            if (ele) {
                _top = ele.position().top;
            }
            }
            if(el && _top<=0){
            const ele = $("[name=" + el.field + "]").parents(".vx-row");
            if (ele) {
                _top = ele.position().top;
            }
            }
            document.getElementById("scrollableques").scrollTo({
            top: _top,
            left: 0,
            behavior: 'smooth'
            })
    
        },
        conformBenProfile(conform=false){
            this.toggleBenProfileCOnformPopUp(false);
            this.$vs.loading();
            if(conform){
                this.updateBeneficiaryProfile();
            }
            
            this.saveCase(this.tempSave,this.showMessage);
        },
        toggleBenProfileCOnformPopUp(action=false){
            this.showBenProfileSyncPopup = action;

        },
        updateBeneficiaryProfile(){
            var postpetition = {
            userId: this.checkProperty(this.petition,'userId'),
            currentDate: moment().format("YYYY-MM-DD"),
            };
            if(_.has(this.benProfileDetails,'petitionerQuestInfo')){
            postpetition['petitionerQuestInfo'] = this.benProfileDetails.petitionerQuestInfo;
            }
            if(_.has(this.benProfileDetails,'documents')){
            postpetition['documents'] = this.benProfileDetails.documents;
            }
            if(_.has(this.benProfileDetails,'dependentsInfo') && this.checkProperty(this.benProfileDetails,'dependentsInfo', 'spouse') && this.checkProperty(this.benProfileDetails['dependentsInfo'], 'spouse', 'documents') ){
            postpetition['dependentsInfo'] ={
                spouse:{
                documents:null
                }
            }

            postpetition['dependentsInfo']['spouse']['documents'] = this.checkProperty(this.benProfileDetails['dependentsInfo'], 'spouse', 'documents');
            postpetition['dependentsInfo']['childrens'] = this.checkProperty(this.benProfileDetails['dependentsInfo'], 'childrens');
            }
            let path = '/beneficiary-profile/update-beneficiary-profile'
            this.$store.dispatch("commonAction", {data:postpetition,path:path}).then((res)=>{
                this.showBenProfileSyncPopup = false;
            }).catch((err)=>{
                
            })
        },
        questionnairePrefil(tplsection='petitionerQuestInfo'){
            this.executionCompleted = false; 
            let questionnaireSection = tplsection;
            if(questionnaireSection == 'petitionerQuestInfo' ){
                _.forEach(this.petition[questionnaireSection], (item,key)=>{
                    if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.ignoreItems.indexOf(key)<=-1){
                        this.petition[questionnaireSection][key] = _.cloneDeep(this.tempPetition[questionnaireSection][key]);
                        // delete this.benProfileDetails[questionnaireSection][key]
                    }
                })
            }
            if(questionnaireSection == 'dateOfBenfEmployment' ){
                if(this.canRenderField( 'dateOfBenfEmployment', this.questionnaireDetails ,false, 'petitionerQuestInfo.dateOfBenfEmployment')){
                    if(this.checkProperty(this.petition, 'petitionerQuestInfo', 'dateOfBenfEmployment') && this.checkProperty(this.petition['petitionerQuestInfo'], 'dateOfBenfEmployment', 'length')>0){
                        _.forEach(this.petition['petitionerQuestInfo']['dateOfBenfEmployment'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'petitionerQuestInfo.dateOfBenfEmployment')){
                                this.petition['petitionerQuestInfo']['dateOfBenfEmployment'][key] = _.cloneDeep(this.tempPetition['petitionerQuestInfo']['dateOfBenfEmployment'][0][key]);
                            }
                        })
                    }else{ 
                        this.petition['petitionerQuestInfo']['dateOfBenfEmployment'] = [];
                        this.petition['petitionerQuestInfo']['dateOfBenfEmployment'].push(this.getBenfEmploymentObj())

                    }
                }else{
                    this.petition['petitionerQuestInfo']['dateOfBenfEmployment'] = [];
                    this.petition['petitionerQuestInfo']['dateOfBenfEmployment'].push(this.getBenfEmploymentObj())
                }
            }
            if(questionnaireSection == 'desPerStockOwnerShip' ){
                if(this.canRenderField( 'desPerStockOwnerShip', this.questionnaireDetails ,false, 'petitionerQuestInfo.desPerStockOwnerShip')){
                    if(this.checkProperty(this.petition, 'petitionerQuestInfo', 'desPerStockOwnerShip') && this.checkProperty(this.petition['petitionerQuestInfo'], 'desPerStockOwnerShip', 'length')>0){
                        _.forEach(this.petition['petitionerQuestInfo']['desPerStockOwnerShip'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'petitionerQuestInfo.desPerStockOwnerShip')){
                                this.petition['petitionerQuestInfo']['desPerStockOwnerShip'][key] = _.cloneDeep(this.tempPetition['petitionerQuestInfo']['desPerStockOwnerShip'][0][key]);
                            }
                        })
                    }else{ 
                        this.petition['petitionerQuestInfo']['desPerStockOwnerShip'] = [];
                        this.petition['petitionerQuestInfo']['desPerStockOwnerShip'].push(this.getBenfEmploymentObj())

                    }
                }else{
                    this.petition['petitionerQuestInfo']['desPerStockOwnerShip'] = [];
                    this.petition['petitionerQuestInfo']['desPerStockOwnerShip'].push(this.getBenfEmploymentObj())
                }
            }
            if(questionnaireSection == 'usaCompanyDocuments'){
                if(this.checkProperty(this.petition['petitionerQuestInfo'], 'usaCompanyDocuments')){
                    _.forEach(this.petition['petitionerQuestInfo']['usaCompanyDocuments'], (item,key)=>{
                        if(!this.canRenderField( key, this.questionnaireDetails ,false, 'petitionerQuestInfo.usaCompanyDocuments')){
                            this.petition['petitionerQuestInfo']['usaCompanyDocuments'][key] = [];
                        }
                    })
                }
                
            }
            if(questionnaireSection == 'foreignCompanyDocuments'){
                if(this.checkProperty(this.petition['petitionerQuestInfo'], 'foreignCompanyDocuments')){
                    _.forEach(this.petition['petitionerQuestInfo']['foreignCompanyDocuments'], (item,key)=>{
                        if(!this.canRenderField( key, this.questionnaireDetails ,false, 'petitionerQuestInfo.foreignCompanyDocuments')){
                            this.petition['petitionerQuestInfo']['foreignCompanyDocuments'][key] = [];
                        }
                    })
                }
            }
        },
        submitCase() {
            this.$validator.validateAll(this.currentTab + "form").then((result) => {
            let self =this;
            //   this.setActiveTab(this.tabslist[this.checkActiveTab + 1].key);
            if (result) {
                if (this.checkActiveTab < this.tabslist.length - 1) {
                this.setActiveTab(this.tabslist[this.checkActiveTab + 1].key);
                setTimeout(function () {
                    document.getElementById("scrollableques").scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                    })
                }, 500)
                }
                else {
                    if((this.consentChecked && this.termsAndConditionsChecked && [50,51].indexOf(this.getUserRoleId)>-1&&this.checkProperty(this.configDetails, 'acceptConsentAndTAndC')) ||
                    ([50,51].indexOf(this.getUserRoleId)<=-1||( 
                    [50, 51].indexOf(this.getUserRoleId) > -1 && 
                    !this.checkProperty(this.configDetails, 'acceptConsentAndTAndC')
                    ))){
                        if (this.petition.questionnaireFilled|| 
                        (this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length')>0 && this.petition.completedActivities.indexOf('SUBMIT_BY_PETITIONER')>-1)) {
                            self.tempSave =true;
                            self.showMessage = false
                            //this.benProfileDetails = _.cloneDeep(this.petition);
                            //this.toggleBenProfileCOnformPopUp(true);
                            this.saveCase(true, false, true);
                        } else {
                            this.updateL1Docs(true);
                            this.conditionalBasis();
                            //this.benProfileDetails = _.cloneDeep(this.petition);
                            this.callQuestionairePrefill();
                            let temp_save = false;
                            this.questionnairePreviewData = {
                            petitionId: this.$route.params.itemId,
                            userName: this.$store.state.user.name,
                            typeName: this.petition.typeDetails.name,
                            subTypeDetails:this.petition.subTypeDetails,
                            typeDetails: this.petition.typeDetails,
                            subTypeDetails: this.petition.subTypeDetails,
                            highestDegreeList: this.petition.highestDegreeList,
                            action: temp_save ? "PETITIONER_INFO_UPDATE" : "SUBMIT_BY_PETITIONER",
                            currentDate: moment().format("YYYY-MM-DD"),
                            petitionerQuestInfo: this.petition.petitionerQuestInfo,
                            temp_save: false,
                            questionnaireFilled: true,
                            today: moment().format("YYYY-MM-DD"),
                            questionnaireTplType: this.petition.questionnaireTplType,
                            };
                            this.questionnairePreviewData.noOfDaysStayInUS = this.gettotalDays;
                            this.questionnairePreview = true;
                            this.questionnaireLoader = false;
                        }
                    }else{
                        this.$validator.validateAll("consentTermsForm")
                    }
                    
                }
            }
            else {
                this.validateandScroll();
            }
            })
        },
        saveCase(temp_save, show_message = true, checkMasters) {
            //this.benProfileDetails = _.cloneDeep(this.petition);
            this.callQuestionairePrefill();
            this.updateL1Docs(true);
            this.conditionalBasis();
            var postpetition = {
            petitionId: this.$route.params.itemId,
            userName: this.$store.state.user.name,
            action: temp_save ? "PETITIONER_INFO_UPDATE" : "SUBMIT_BY_PETITIONER",
            type:this.checkProperty(this.petition,'typeDetails','id'),
            typeName: this.petition.typeDetails.name,
            subType: this.checkProperty(this.petition,'subTypeDetails','id'),
            subTypeName:this.checkProperty(this.petition,'subTypeDetails','name'),
            currentDate: moment().format("YYYY-MM-DD"),
            petitionerQuestInfo: this.petition.petitionerQuestInfo,
            temp_save: temp_save,
            questionnaireFilled: temp_save ? false : true,
            today: moment().format("YYYY-MM-DD"),
            consentChecked: this.consentChecked,
            termsAndConditionsChecked: this.termsAndConditionsChecked,
            };
            if (this.checkProperty(this.petition, 'questionnaireFilled')) {
            postpetition['questionnaireUpdate'] = true
            }
            this.$vs.loading();
            if (!this.checkCurrentUrl) {  
                postpetition['submittedWithLink'] = true;
            }
            this.questionnaireLoader = true
            this.$store.dispatch("petitioner/petitionupdate", postpetition)
                        .then((response) => {
                            this.showBenProfileSyncPopup = false;
                            if (this.checkProperty(response, "error")) {
        
                                if (show_message) {
        
                                    this.showToster({
                                        message: response.error.message,
                                        isError: true,
                                    });
                                } else {
        
                                    this.$vs.loading.close();
                                }
        
                            } else {
        
                                this.spouseModalForm = false;
                                this.childModalForm = false;
                                if (show_message) {
                                    
                                
                                    if (!temp_save) {
                                        this.SuccessQuestionnaire = true;
                                    } else {
        
                                        this.showToster({
                                            message: "Questionnaire saved successfully",
                                            isError: false,
                                        });
                                    }
        
                                } else {


                                    let currentRoute = this.$route;

                                    if (  !this.checkCurrentUrl &&   _.get(currentRoute, "name", "") == "fill-Petitioner-questionnaire" &&  _.has(currentRoute, "meta.getTokenFromUrl") &&
                                    _.has(currentRoute, "query.token")
                                    ) {
                                        let token = _.get(currentRoute, "query.token", "");
                                        let url = "/filled-case-details/" +this.$route.params.itemId + "?token=" + token;
                                    //   window.location.href = window.location.origin+'/app'+url

                                        this.showToster({  message: "Questionnaire saved successfully",  isError: false,  });
                                    
                                        this.$router.push(url) //petitionId

                                    }else if (this.petition.questionnaireFilled) {
                                        this.showToster({ message: "Questionnaire updated successfully",   isError: false,  });

                                        if (this.checkProperty(this.petition, "rfeCase")) {
                                            this.$router.push("/rfe-petition-details/" + this.$route.params.itemId);
                                    } else {
                                        this.$router.push("/petition-details/" + this.$route.params.itemId);
                                        }
        
                                    } else {
                                        
        
                                        if (!temp_save) {
                                            this.questionnairePreview = false;
                                            this.$vs.loading.close();
                                            this.SuccessQuestionnaire = true;
                                            //let currentRoute = this.$route;
                                            // if(!this.checkCurrentUrl && _.get(currentRoute, "name", "") == "fill-Petitioner-questionnaire"){
                                            //     document.addEventListener("click", this.reloadthePage());
                                            // }
                                        } else {
                                            this.questionnairePreview = false;
                                            this.showToster({ message: "Questionnaire updated successfully",   isError: false,  });
                                            this.$vs.loading.close();
                                            if (this.checkProperty(this.petition, "rfeCase")) {
                                                this.$router.push("/rfe-petition-details/" + this.$route.params.itemId);
                                            } else {
                                                this.$router.push("/petition-details/" + this.$route.params.itemId);
                                            }
                                        }
        
                                    }
        
                                }
                            }
        
                            this.$vs.loading.close();
        
                    }).catch((err) => {
                this.$vs.loading.close();
                this.questionnaireLoader = false;
                this.showToster({ message: err, isError: true, });
                })
        
        },
        callQuestionairePrefill(){ 
            this.questionnairePrefil('petitionerQuestInfo');
            this.questionnairePrefil('dateOfBenfEmployment');
            this.questionnairePrefil('desPerStockOwnerShip');
            this.questionnairePrefil('usaCompanyDocuments');
            this.questionnairePrefil('foreignCompanyDocuments');
        },
        reloadthePage(redirect = false) {
            let routeTest = this.$route.params.itemId;

            var _self = this;
            if (this.SuccessQuestionnaire) {
                this.SuccessQuestionnaire = false;
            }
            if(redirect){
                this.SuccessQuestionnaire = false;
                setTimeout(()=>{
                    _self.SuccessQuestionnaire = false;
                    // _self.$router.push({ name: "questionnaire", params: { itemId: routeTest, 'redirect':true} });
                    _self.$router.push("/questionnaire/"+routeTest+"?redirect=true");
                    
                },5)
                
                //_self.$router.push("/rfe-petition-details/" + routeTest);
            }else{
                setTimeout(() => {
                    this.SuccessQuestionnaire = false;
                let currentRoute = _self.$route;

                if (
                    _.get(currentRoute, "name", "") == "fill-Petitioner-questionnaire" &&
                    _.has(currentRoute, "meta.getTokenFromUrl") &&
                    _.has(currentRoute, "query.token")
                ) {
                    let token = _.get(currentRoute, "query.token", "");
                    let url = "/filled-case-details/" + routeTest + "?token=" + token;
                    //   window.location.href = window.location.origin+'/app'+url
                    _self.$router.push(url);
                } else {
                    if (_self.checkProperty(_self.petition, "rfeCase")) {
                        _self.$router.push("/rfe-petition-details/" + routeTest);
                    } else {
                        _self.$router.push("/petition-details/" + routeTest);
                    }
                }
            }, 10);
            }
        },
        prefilltheDetails() {
            // let tempPetition = _.cloneDeep(this.latestPetition);
            // var data = _.merge(this.petition, tempPetition);
            // this.petition = data;
            this.prepopulateQuestionnaire('petitionerQuestInfo');
            this.prepopulateQuestionnaire('dateOfBenfEmployment');
            this.prepopulateQuestionnaire('desPerStockOwnerShip');
            this.prepopulateQuestionnaire('usaCompanyDocuments');
            this.prepopulateQuestionnaire('foreignCompanyDocuments');
            this.setTheInitData()
        },
        setBasicData() {
            if (this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'email')) {
            this.petition['petitionerQuestInfo']['email'] = this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'email')
            }
            if (this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'firstName')) {
            this.petition['petitionerQuestInfo']['firstName'] = this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'firstName');
            }
            if (this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'middleName')) {
            this.petition['petitionerQuestInfo']['middleName'] = this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'middleName');
            }
            if (this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'lastName')) {
            this.petition['petitionerQuestInfo']['lastName'] = this.checkProperty(this.latestPetition, 'petitionerQuestInfo', 'lastName');
            }
    
            this.petition['petitionerQuestInfo']['homePhoneCountryCode'] = {
            "countryCode": "US",
            "countryCallingCode": "1"
            }
            this.petition['petitionerQuestInfo']['cellPhoneCountryCode'] = {
            "countryCode": "US",
            "countryCallingCode": "1"
            }
            this.docsList[0]['required'] = this.checkSLGAndRenderField
        },
        setTheInitData() {
            if(this.petition, 'petitionerQuestInfo'){
                if(this.checkProperty(this.petition, 'petitionerQuestInfo') &&
                 (!this.checkProperty(this.petition, 'petitionerQuestInfo', 'dateOfBenfEmployment') || this.checkProperty(this.petition['petitionerQuestInfo'], 'dateOfBenfEmployment', 'length')<=0 )){
                    this.petition.petitionerQuestInfo['dateOfBenfEmployment'] = [];
                    this.petition.petitionerQuestInfo['dateOfBenfEmployment'].push(this.getBenfEmploymentObj());
                }
                if(this.checkProperty(this.petition, 'petitionerQuestInfo') &&
                 (!this.checkProperty(this.petition, 'petitionerQuestInfo', 'desPerStockOwnerShip') || this.checkProperty(this.petition['petitionerQuestInfo'], 'desPerStockOwnerShip', 'length')<=0 )){
                    this.petition.petitionerQuestInfo['desPerStockOwnerShip'] = [];
                    this.petition.petitionerQuestInfo['desPerStockOwnerShip'].push(this.getStockOwnerShipObj());
                }
                if(this.checkProperty(this.petition, 'petitionerQuestInfo') &&
                 !this.checkProperty(this.petition, 'petitionerQuestInfo', 'usaCompanyDocuments') ){
                    this.petition.petitionerQuestInfo = Object.assign(this.petition.petitionerQuestInfo, {'usaCompanyDocuments':this.getUsaCompanyDocs()});
                    // this.petition.petitionerQuestInfo['usaCompanyDocuments'] = this.getUsaCompanyDocs();
                }
                if(this.checkProperty(this.petition, 'petitionerQuestInfo') &&
                 !this.checkProperty(this.petition, 'petitionerQuestInfo', 'foreignCompanyDocuments') ){
                    this.petition.petitionerQuestInfo = Object.assign(this.petition.petitionerQuestInfo, {'foreignCompanyDocuments':this.getForeignCompanyDocs()});
                    // this.petition.petitionerQuestInfo['foreignCompanyDocuments'] = this.getForeignCompanyDocs();
                }
                if(this.checkProperty(this.petition, 'petitionerQuestInfo') &&
                 (!this.checkProperty(this.petition, 'petitionerQuestInfo', 'address') ||  this.checkProperty(this.petition, 'petitionerQuestInfo', 'address')== null  )){
                    this.petition.petitionerQuestInfo = Object.assign(this.petition.petitionerQuestInfo, {'address':this.getAddressObj()});
                    // this.petition.petitionerQuestInfo['address'] = this.getAddressObj();
                }
                if(this.checkProperty(this.petition, 'petitionerQuestInfo') &&
                 (!this.checkProperty(this.petition, 'petitionerQuestInfo', 'workAddress') ||  this.checkProperty(this.petition, 'petitionerQuestInfo', 'workAddress')== null  )){
                    this.petition.petitionerQuestInfo = Object.assign(this.petition.petitionerQuestInfo, {'workAddress':this.getAddressObj()});
                    // this.petition.petitionerQuestInfo['workAddress'] = this.getAddressObj();
                }
            }
            this.featureDates = new Date();
            var $self = this;
            this.$vs.loading.close();
        },
        loadStatesByCountry(model, countryId) {
            this.$store.dispatch("getstates", countryId).then((response) => {
            switch (model) {
                case "bfeprovinceStates":
                this.bfeprovinceStates = response;
                break;
                case "usastates":
                this.usastates = response;
                break;
            }
            });
        },
        goBack() {
            this.setActiveTab(this.tabslist[this.checkActiveTab - 1].key)
        },
        setActiveTab(item, validate = false) {
            if (validate) {
            this.$validator.validateAll(this.currentTab + "form").then((result) => {
                if (result) {
                    if(item == 'documents'){
                        this.updateL1Docs()
                    }
                    this.currentTab = item;
                    document.getElementById("scrollableques").scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                } else {
                    this.validateandScroll()
                }
            })
            } else {
            this.currentTab = item;
            setTimeout(function () {
                document.getElementById("scrollableques").scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
                })
            }, 500)
            }
    
        },
        emitUploadingAction(data){
                    if(_.has(data,'docMainCategory')){
                        _.map(this[data['docMainCategory']],(item)=>{
                            if(item['fieldName'] == data['fieldName']){
                                item = Object.assign( item ,{ "fileUploading": false})
                                item['fileUploading'] = data['action'] 
                            }
                        })
                    }
                    if(_.has(data,'allFilesAreUploaded')){
                        if(data['allFilesAreUploaded'] && this.checkProperty(data,'uploadFIlesErrors', 'length') >0){
                            let joinedError = '';
                                    if(data['uploadFIlesErrors'].length>0){
                                        joinedError = data['uploadFIlesErrors'].join(", ")
                                    }
                            this.showToster({
                                            message:joinedError,
                                            isError: true,
                                        });

                        }

                    }
                    this.checkSubmitBtn(data)
        },
        checkSubmitBtn(data){
            this.documentUploading = false;
            if(_.has(data,'docMainCategory')){
                _.forEach(this[data['docMainCategory']],(item)=>{
                    if(_.has(item,'fileUploading') && item['fileUploading']){
                        this.documentUploading = true;
                        return false;
                    }
                })
            }
        }, 
        getBenfEmploymentObj(){
            let obj = {
                explaOfInterruptions: '',
                dateOfEmpFrom: null,
                dateOfEmpTo: null
            };
            return obj;
        },
        getStockOwnerShipObj(){
            let obj = {
                perOfCompany: '',
                fedEmpIdentification: ''
            };
            return obj;
        },
        getUsaCompanyDocs(){
            let obj = {
                incorporationCertDocs: [],  // Certificate of Incorporation
                amendmentCertDocs: [], // Certificate of Amendment of Certificate of Incorporation
                stockCopyCertDocs: [], // Copy of stock certificates
                leaAgreeForPropOffice: [], // Lease Agreements for the proposed office (only for L1A and to open new office)
                curOrgaChart: [], // Current Organizational Chart
                propOrgaChart: [], // Proposed Organizational Chart (only for L1A and to open new office)
                l1AVisaBusiPlan: [], //L1-A Visa Business Plan (only for L1A and to open new office)
                minOfBoardMeetings: [], // Minutes of Board Meetings (optional)
                contraExecOfCopyDocs: [], // Copy of the contracts executed (optional)
                auditFinaStatMostRecent: [], // Most recent audited financial statements or Federal Tax Returns
                bankIndicAndBal: [], // Letter from bank indicating status and balance (only for L1A and to open new office)
                productDocs: [], // Product Documents (Only for L1B) optional
            }
            return obj;
        },
        getForeignCompanyDocs(){
            let obj = {
                taxReturns: [], // Income tax Returns
                bankStatements: [], // Bank Statements
                verifyOrSupportLetter: [], // Verification/Support Letter
                orgnaStructureDocs: [], //Organization Structure
                proAndLossStatDocs: [] // Profit and Loss Statements of Foreign Company
            }
            return obj;
        },
        getAddressObj(){
            let obj ={
                line1: null,
                line2: null,
                aptType: null,
                locationId: null,
                locationDetails: null,
                stateId: null,
                stateDetails: null,
                countryId: null,
                countryDetails: null,
                zipcode: null
            }
            return obj
        }
    
    },
    beforeDestroy() {
      try {
        const $ = JQuery;
        document.removeEventListener("click", this.reloadthePage);
        $('body').removeClass('questionnairetpl')
      } catch (err) {
      }
    },
    computed: {
        getConsentVal(){
            let returnVal = '';
            if(this.consentChecked){
                returnVal = 'consentChecked';
            }
            return returnVal;
        },
        getTermsVal(){
            let returnVal = '';
            if(this.termsAndConditionsChecked){
                returnVal = 'termsAndConditionsChecked';
            }
            return returnVal;
        },
        getLabelContent(){
            let returnVal = '';
            if(this.contentCategory == 'consent'){
                returnVal = 'Consent to Process Personal Data';
            }
            if(this.contentCategory == 'termsAndConditions'){
                returnVal = 'Terms and Conditions';
            }
            return returnVal
        },
      checkEmailRequired(){
        let returnVal = true;
        if(this.checkProperty(this.petition,'tempUser') && this.checkProperty(this.petition,'questionnaireTplType') == 'general' ){
          returnVal = false;
        }
        return returnVal
      },
     
  
      checkActiveTab() {
        return _.findIndex(this.tabslist, { "key": this.currentTab });
      },
      actiontype() {
        if (this.checkActiveTab == (this.tabslist.length - 1)) {
          if (this.petition.questionnaireFilled || 
          (this.checkProperty(this.petition, 'completedActivities') && this.checkProperty(this.petition, 'completedActivities', 'length')>0 && this.petition.completedActivities.indexOf('SUBMIT_BY_PETITIONER')>-1)) {
            return "Update";
          }
          if (!this.petition.questionnaireFilled) {
            return "Review & Submit";
          }
          return "Submit";
        }
        return "Next";
      },
      checkSLGAndRenderField() {
        if (this.checkProperty(this.petition, 'questionnaireTplType')
          && this.petition.questionnaireTplType == 'slg') {
          return true
        }
        return false
      },
  
      checkEduTranscriptsDocumentsRequired() {
        if (!this.checkSLGAndRenderField) {
          if (this.checkProperty(this.petition,'petitionerQuestInfo', 'mastersUniversityName')) {
            this.eduDocsList[0]['required'] = false
            return false
          }else{
            this.eduDocsList[0]['required'] = false
            return true
          }
        }
        return true
      }, checkMastersUniversityNameRequired() {
        if (!this.checkSLGAndRenderField) {
          if (this.checkProperty(this.petition, 'documents', 'eduTranscripts')
            && this.petition['documents']['eduTranscripts'].length > 0)
            return false
        }
        return true
      },

      getCaseName(){
        //petition.typeDetails.name
        let s =this.checkProperty(this.petition ,'typeDetails','name');
        if(s){
            s='Questionnaire for '+s;
            if( this.checkProperty(this.petition ,'subTypeDetails','name') ){
                s=s+" <small>"+this.petition.subTypeDetails.name+"</small"
            }
            return s.replace(/(\d)/g, '<span class="number">$1</span>');
        }else{
            return '';
        }

    },
  
    },
    mounted() {
        const $ = JQuery;
        this.$vs.loading();
        $('body').addClass('questionnairetpl');
        let localData = localStorage.getItem("pinAccessData");
        let action=true;
        if(localData){
            localData = JSON.parse(atob(localData));
        }else{
            localData =[];
        }
        let userData = this.getUserData;
        if(_.find(localData ,{ "userId":userData["userId"],"petitionId": this.$route.params.itemId })){
            action =false;
            this.tokenVerified =true;
        }
        this.getConsentDetails();
        this.getGlobalConfigDetails()
        this.init(action);
        this.loadStatesByCountry('usastates', 231)
    }
  };
  </script>